import React, { Fragment, useState } from 'react'
import { Collapse, Button } from 'reactstrap'
import DialogueCommentBlock from './dialogue-comment-block'
import DialogueCommentInputfield from './dialogue-comment-inputfield'
import IconReplies from '../images/icon-replies.svg'
import { compose } from 'redux'
import { withRouter } from 'react-router'
import { withTranslations } from '../decorators/with-translations'

const CommentAndReplyGroup = ({ i, questionId, useTranslate, isAfterGameGuest, disableActions }) => {
  const t = (phrase) => useTranslate(`discussion.${phrase}`)
  const [repliesOpen, setRepliesOpen] = useState(false)
  const [replyInputOpen, setReplyInputOpen] = useState(false)

  if (i) {
    return (
      <div>
        <DialogueCommentBlock
          questionId={questionId}
          i={i}
          isAfterGameGuest={isAfterGameGuest}
          disableActions={disableActions}
          onReplyClick={() => {
            setRepliesOpen(true)
            setReplyInputOpen(!replyInputOpen)}
          }
        />
        {i.replies && i.replies.length !== 0 &&
        <div className={`comment-replies ${repliesOpen ? 'open' : ''}`}>
          <Button onClick={() => setRepliesOpen(!repliesOpen)} color="link" className="btn-toggle-comments">
            <img src={IconReplies} alt="icon"/>{!repliesOpen[i.comId] ? `${i.replies.length} ${t("replies")}` : `${t("more_answers")}`}
          </Button>
          <Collapse isOpen={repliesOpen}>
            {i.replies && i.replies.map((a, index) => {
              return (
                <DialogueCommentBlock
                  key={index}
                  i={a}
                  parentId={i.id}
                  reply
                  questionId={questionId}
                  isAfterGameGuest={isAfterGameGuest}
                  disableActions={disableActions}
                  onReplyClick={() => {
                    setRepliesOpen(true)
                    setReplyInputOpen(!replyInputOpen)}
                  }
                />
              )
            })}
          </Collapse>
        </div>
        }
        {(replyInputOpen && !disableActions) && (
            <DialogueCommentInputfield
              cancellor={i.comId}
              questionId={questionId}
              parentId={i.id}
              autofocus
              onCommentFinish={() => setReplyInputOpen(false)}
            />
          )}
      </div>
    )
  }

  return null
}

const DialogueCommentTree = ({ commentData, inputRef, questionId, useTranslate, isAfterGameGuest, disableActions }) => {
  const t = (phrase) => useTranslate(`discussion.${phrase}`);

  return (
    <Fragment>
      {!disableActions &&
        <DialogueCommentInputfield inputRef={inputRef} questionId={questionId} />
      }
      <div className="comment-tree">
        {commentData.map((i, index) =>
          <CommentAndReplyGroup
            key={index}
            i={i}
            questionId={questionId}
            useTranslate={useTranslate}
            isAfterGameGuest={isAfterGameGuest}
            disableActions={disableActions}
          />
        )}
        {!commentData.length && (
          <p className="mb-0">
            {(isAfterGameGuest || disableActions) ? t("no_answers_yet_guest_user") : t("no_answers_yet")}
          </p>
        )}
      </div>
    </Fragment>
  )
}

export default compose(
  withRouter,
  withTranslations,
)(DialogueCommentTree)


// WEBPACK FOOTER //
// ./src/components/dialogue-comment-tree.js